export const PROPERTY_ANALYTICS_TOP_PROPERTIES_LIMIT = 7;
export const PROPERTY_ANALYTICS_TABLE_PAGE_SIZE = 10;
